import { DateTime } from 'luxon';

export const toDateTime = (date: string) =>
    DateTime.fromFormat(date, 'yyyy-MM-dd');
